import script from "./CalcoloScoresInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalcoloScoresInput.vue?vue&type=script&setup=true&lang=ts"

import "./CalcoloScoresInput.vue?vue&type=style&index=0&id=51726c06&lang=css"

const __exports__ = script;

export default __exports__